import React from "react";
import { Header } from "semantic-ui-react";
import PropTypes from "prop-types";

const CuentaDetailHeader = ({ cuenta }) => {
  return (
    <Header as="h2" color="blue">
      {cuenta.nombreTipoProductoCuenta}
    </Header>
  );
};

CuentaDetailHeader.propTypes = {
  cuenta: PropTypes.object.isRequired,
};

export default CuentaDetailHeader;
